
import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import {} from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import LandingPage from 'views/LandingPage/LandingPage';
// import NewRecord from 'views/admin/NewRecord/NewRecord';
import {
  ChakraProvider,
// extendTheme
} from '@chakra-ui/react';
import initialTheme from './theme/theme'; //  { themeGreen }
import { useState } from 'react';

// Chakra imports

export default function Main() {
  // eslint-disable-next-line
  const [currentTheme, setCurrentTheme] = useState(initialTheme);

  return (
    <ChakraProvider theme={currentTheme}>
      <Routes>
        <Route path="auth/*" element={<AuthLayout />} />

        <Route
          path="admin/*"
          element={
            <AdminLayout
              theme={currentTheme}
              setTheme={setCurrentTheme}
            />
          }
        />

        <Route path="LandingPage/*" element={<LandingPage />} />

        {/* Default Route */}
        <Route path="/" element={<Navigate to="/LandingPage" replace />} />
      </Routes>
    </ChakraProvider>
  );
}